import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { AppName, CleanMessage } from "../../util/app";
import { toast } from "react-toastify";
import { useMutation } from "react-apollo";
import LoadingSpinner from "../../partials/loading";
import PrimaryButton from "../../partials/Buttons/PrimaryButton";
import { SET_DOCTOR } from "../../queries/patient.query";
import DesignationDownList from "../../partials/DesignationDownList";
import UserByDesignationDropdown from "../../partials/UserByDesignationDowndown";

const PatientPersonalDoctor = ({ match }) => {
    const [staff, setStaff] = useState();
    const { id } = match.params;
    const [des, setDes] = useState();

    const _profileLink = "/home/patient/profile/" + id + "/summary";

    const [setDoctorFunc, { loading: dLoading }] = useMutation(SET_DOCTOR, {
        onError: e => toast.error(CleanMessage(e.message)),
        onCompleted: d => {
            if (d.UpdateDoctor) {
                const { message } = d.UpdateDoctor;
                setStaff(null);
                toast.success(message);
                setTimeout(() => {
                    window.document.location.href = _profileLink;
                }, 100);
            }
        }
    });

    const title = "Updates Patient' Doctor";
    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-head">
                            <header>{title}</header>
                        </div>
                        <div className="card-body min-card">
                            <div className="row">
                                <div className="col-6">
                                    <DesignationDownList onChange={item => item && setDes(item.id)} />
                                </div>
                                <div className="col-6">
                                    <UserByDesignationDropdown onChange={item => item && setStaff(item)} designation={des} />
                                </div>
                            </div>
                            <LoadingSpinner loading={dLoading} bar={true} />
                            <div className="p-l-20" style={{ padding: "20px" }}>
                                <center className="mt-3">
                                    <h5>Enter staff's email address or registration number to continue</h5>
                                </center>
                                {staff && (
                                    <div className="mt-5 fade-in text-center">
                                        <h4>{staff.name}</h4>
                                        <hr />
                                        <div className="mt-5">
                                            <PrimaryButton
                                                title="Assign Doctor"
                                                onClick={async () => {
                                                    if (id && window.confirm(`Are you sure you want to assign ${staff.name} to this patient?`)) {
                                                        await setDoctorFunc({
                                                            variables: { id, staff: staff.id }
                                                        });
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PatientPersonalDoctor;
